import React from "react";
import { Snackbar, SnackbarContent } from "@material-ui/core";

export default props => {
    return (
        <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            open={props.open}
            autoHideDuration={6000}
            onClose={props.onClose}
        >
            <SnackbarContent
                style={{ backgroundColor: props.color, color: "white" }}
                message={props.message}
            />
        </Snackbar>
    );
};
